import { render } from "./DesignsPage.vue?vue&type=template&id=befa4d52&scoped=true"
import script from "./DesignsPage.vue?vue&type=script&lang=js"
export * from "./DesignsPage.vue?vue&type=script&lang=js"

import "./DesignsPage.vue?vue&type=style&index=0&id=befa4d52&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-befa4d52"]])

export default __exports__